"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getButtonClassnameForProduct(lenderName, variant) {
    if (variant === 'warn') {
        switch (lenderName) {
            case 'AFF':
                return 'button-warn-access';
            case 'Imprint':
                return 'button-warn-advantage';
            case 'ADS':
                return 'button-warn';
            default:
                return 'button-warn';
        }
    }
    else if (variant === 'outline') {
        switch (lenderName) {
            case 'AFF':
                return 'button-warn-access-outline';
            case 'Imprint':
                return 'button-warn-advantage-outline';
            case 'ADS':
                return 'button-warn-outline';
            default:
                return 'button-warn-outline';
        }
    }
}
exports.default = getButtonClassnameForProduct;
